module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '\n\nfunction getIndex(array, obj) {\n    if (array == null) {\n        throw new TypeError();\n    }\n\n    var i,\n        len;\n\n    len = array.length;\n\n    for (i = 0; i < len; i++) {\n        if (array[i].equals(obj)) {\n            return i;\n        }\n    }\n\n    return -1;\n};\n\nmodule.exports = getIndex;';

}
return __p
}